<template>
  <output
    :class="['mini-toast', classes, variant]"
    aria-live="polite"
    aria-atomic="true"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <slot />
  </output>
</template>

<script lang="ts">
import { defineComponent, PropType, reactive } from 'vue';

type ToastType = 'success' | 'error';

export default defineComponent({
  props: {
    variant: {
      type: String as PropType<ToastType>,
      default: 'success',
    },
    duration: {
      type: Number,
      default: 2000,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['hide'],
  setup(props, { emit, expose }) {
    let timeout: ReturnType<typeof setTimeout>;

    const classes = reactive({
      hide: true,
    });

    function activeHideTimeout(time = props.duration) {
      clearTimeout(timeout);

      timeout = setTimeout(() => {
        classes.hide = true;
        emit('hide');
      }, time);
    }

    function show() {
      classes.hide = false;
      if (!props.persistent) {
        activeHideTimeout();
      }
    }

    function hide() {
      clearTimeout(timeout);
      classes.hide = true;
      emit('hide');
    }

    function onMouseEnter() {
      if (props.persistent) return;
      clearTimeout(timeout);
    }

    function onMouseLeave() {
      if (props.persistent) return;
      activeHideTimeout(1000);
    }

    expose({ show, hide });

    return {
      classes,

      show,
      hide,

      onMouseEnter,
      onMouseLeave,
    };
  },
});
</script>

<style lang="scss" scoped>
.mini-toast {
  padding: 8px;
  border-radius: 8px;
  font-size: .875rem;
  background-color: var(--acerto-colors-green-500);
  color: white;

  &.hide {
    display: none;
  }

  &.error {
    background-color: var(--acerto-colors-red-500);
  }
}
</style>
